import { createContext } from "react";

const MeetingContext = createContext();

export default MeetingContext